import { observer } from 'mobx-react';
import { FC, MouseEvent, ReactElement, useCallback, useMemo } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import { IMenuProduct } from '~/types/products';
import Icon from '~/view/components/Controls/Icon/Icon';
import { useCheckoutStoreContext } from '~/view/screens/CheckoutScreen/context';
import './style.scss';

interface IProps {
  product: IMenuProduct;
}

export const OrderCartProductHeader: FC<IProps> = observer(({ product }: IProps): ReactElement => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const sizeName = useMemo((): string | undefined => (product.size ? `(${product.size.name})` : undefined), [product.size]);

  const onRemoveProduct = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      event.stopPropagation();
      checkoutStore.onRemoveProduct(product);
    },
    [product]
  );

  return (
    <div className="order-cart-product-header">
      <div className="d-flex flex-row align-items-center gap-10 pr-2">
        <div className="d-flex flex-row align-items-center">
          <span className="order-cart-product-header__name">{product.name}</span>
          {sizeName && <span className="order-cart-product-header__name order-cart-product-header__size-name text-break ml-1">{sizeName}</span>}
        </div>

        <Icon name={Icons.Pencil} size={12} color={theme.colors.dark} />
      </div>

      {checkoutStore.dependencies.order?.use_wallet ? null : (
        <div onClick={onRemoveProduct}>
          <Icon name={Icons.Close} size={10} color={theme.colors.gray2} />
        </div>
      )}
    </div>
  );
});
